const awaitAnimationFrame = () => new Promise(requestAnimationFrame);

function initMobileSearchButton() {
  const mobileSearchButton = document.querySelector(
    '[data-popup="mob-search"]',
  );
  const mobileSearchInput = document.getElementById("mob-search-input");

  if (!mobileSearchButton || !mobileSearchInput) {
    return;
  }

  mobileSearchButton.addEventListener("click", async () => {
    await awaitAnimationFrame();
    await awaitAnimationFrame();
    mobileSearchInput.focus();
  });
}

initMobileSearchButton();

export {};
